













import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '素早い吸水と速乾力は、汗冷えを軽減してくれます。'
      '首に巻いて日焼け対策をしたり、ターバン風に巻いて汗止めにしたりと使い方さまざま。さりげないオシャレを楽しみながらしっかり汗を吸い取ってくれる優れもの。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
